import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/',
    name: 'Landing',
    component: () => import('../views/Landing.vue'),
  },
  {
    path: '/payment',
    name: 'Payment',
    component: () => import('../views/Payment')
  },
  {
    path: '/payment-detail',
    name: 'PaymentDetail',
    component: () => import('../views/PaymentDetail'),
    props: true
  },
  {
    path: '/contact-us',
    name: 'Contact',
    component: () => import('../views/Contact')
  },
  {
    path: '/setting',
    name: 'Setting',
    component: () => import('../views/Setting')
  },
  {
    path: '/change-battery',
    name: 'ChangeBattery',
    component: () => import('../views/ChangeBattery'),
    props: true
  },
  {
    path: '/complete',
    name: 'ChangeComplete',
    component: () => import('../views/ChangeComplete')
  },
  {
    path: '/policy',
    name: 'PrivacyPolicy',
    component: () => import('../views/Policy')
  },
  {
    path: '/rental-detail',
    name: 'RentalDetail',
    component: () => import('../views/RentalDetail')
  },
  {
    path: '/step-change-battery',
    name: 'StepChangeBattery',
    component: () => import('../views/StepChangeBattery'),
    props: true
  },
  {
    path: '/station',
    name: 'Station',
    component: () => import('../views/Station'),
  },
  {
    path: '/scan-station',
    name: 'ScanStation',
    component: () => import('../views/ScanStation'),
  },
  {
    path: '/close-locker',
    name: 'CloseLocker',
    component: () => import('../views/CloseLocker.vue'),
  },
  // {
  //   path: '/landing',
  //   name: 'Landing',
  //   component: () => import('../views/Landing.vue'),
  // },
  {
    path: '/select-station',
    name: 'SelectStation',
    component: () => import('../views/SelectStation.vue'),
  },
  {
    path: '/test-update-station',
    name: 'UpdateStation',
    component: () => import('../views/DEV/UpdateStation'),
  },
  {
    path: '/scanner',
    name: 'Scanner',
    component: () => import('../views/Scanner'),
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
